module.exports = __webpack_public_path__ + "img/z4.e2c23da4.jpg";